import React from "react";
import { useTranslation } from "react-i18next";
import { useHeader } from "../../contexts/HeaderContext";
import { useTermsDialog } from "../../hooks/useTermsDialog";
import { TermsDialog } from "../../components/TermsDialog";

export const PayFooter: React.FC = () => {
  const { t } = useTranslation();
  const { wbeConfig, selectedLanguage } = useHeader();
  const { termsDialog, openTermsDialog, closeTermsDialog } = useTermsDialog();

  const merchant = wbeConfig?.merchant;
  const generalTerms = wbeConfig?.termsAndConditions.find(
    (term) => term.name === "general-terms",
  );
  const integrityPolicy = wbeConfig?.termsAndConditions.find(
    (term) => term.name === "integrity-policy",
  );

  return (
    <div className="flex flex-col items-center justify-end w-full">
      {/* Divider */}
      <div className="w-full border-t border-border" />

      <div className="grid grid-cols-2 gap-4 px-4 py-6 text-xs leading-5 w-full max-w-[1024px] box-border md:flex md:flex-row md:items-start md:justify-between">
        {merchant && (
          <div className="flex min-w-0 flex-col gap-0.5">
            <p className="font-semibold text-ink break-words">
              {merchant.name}
            </p>
            <p className="text-ink-secondary break-words">
              {merchant.address}
            </p>
            <p className="text-ink-secondary break-words">
              {merchant.zipCode} {merchant.city}
            </p>
          </div>
        )}

        <div className="flex min-w-0 flex-col gap-0.5">
          <p className="font-semibold text-ink">
            {t("paymentlink.footer.contact")}
          </p>
          {wbeConfig?.contactEmail && (
            <a
              href={`mailto:${wbeConfig.contactEmail}`}
              className="text-ink-secondary break-words"
            >
              {wbeConfig.contactEmail}
            </a>
          )}
          {wbeConfig?.contactPhone && (
            <a
              href={`tel:${wbeConfig.contactPhone.replace(/\s+/g, "")}`}
              className="text-ink-secondary break-words"
            >
              {wbeConfig.contactPhone}
            </a>
          )}
        </div>

        <div className="flex min-w-0 flex-col gap-0.5 col-span-2 md:col-span-1">
          <p className="font-semibold text-ink">
            {t("paymentlink.footer.terms")}
          </p>
          {integrityPolicy && (
            <button
              type="button"
              className="text-left text-ink-secondary underline"
              onClick={() =>
                openTermsDialog(integrityPolicy.id, selectedLanguage)
              }
            >
              {t("payment.integrity_policy")}
            </button>
          )}
          {generalTerms && (
            <button
              type="button"
              className="text-left text-ink-secondary underline"
              onClick={() =>
                openTermsDialog(generalTerms.id, selectedLanguage)
              }
            >
              {t("payment.general_terms")}
            </button>
          )}
        </div>
      </div>

      {/* Bottom divider */}
      <div className="w-full border-t border-border" />

      <TermsDialog
        isOpen={termsDialog.isOpen}
        onClose={closeTermsDialog}
        title={termsDialog.title}
        bodyHtml={termsDialog.body}
      />
    </div>
  );
};
